const comments = [
  { name: '影迷小张', text: '蘑菇影院真的太给力了！高清画质完全不卡顿，追剧体验比那些收费平台还好，而且每天都有新片更新，已经推荐给身边所有朋友了。', time: '2小时前', rating: 5 },
  { name: '追剧达人', text: '找了很久的高清电视剧全集资源，终于在蘑菇影院找到了。画质清晰、加载速度快，最重要的是完全免费，真是太良心了！', time: '5小时前', rating: 5 },
  { name: '电影发烧友', text: '作为一个电影迷，蘑菇影院的片库真的让我惊艳。从经典老片到最新院线，分类清晰、播放流畅，简直是影迷的天堂。', time: '1天前', rating: 5 },
  { name: '周末宅家党', text: '周末在家就想找点好片子看，蘑菇影院资源太全了。动作片、喜剧片、悬疑片应有尽有，高清流畅看得过瘾！', time: '1天前', rating: 4 },
  { name: '深夜追剧人', text: '每晚睡前必逛蘑菇影院，更新速度超快。最近热播的几部剧这里都有高清全集，播放一点也不卡，熬夜追剧的快乐谁懂啊！', time: '2天前', rating: 5 },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
              观众热评
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              来看看影迷朋友们对蘑菇影院的真实评价
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {comments.map((comment, i) => (
              <div
                key={i}
                className={`bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/70 ${
                  i === 0 ? 'lg:col-span-2' : ''
                }`}
              >
                <div className="flex items-center gap-1 mb-3">
                  {Array.from({ length: comment.rating }).map((_, j) => (
                    <i key={j} className="ri-star-fill text-accent-500 text-sm"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                  &ldquo;{comment.text}&rdquo;
                </p>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center">
                      <span className="text-xs font-bold text-accent-600">
                        {comment.name.charAt(0)}
                      </span>
                    </div>
                    <span className="text-sm font-medium text-foreground-800">{comment.name}</span>
                  </div>
                  <span className="text-xs text-foreground-500">{comment.time}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}